<script lang="ts" setup>
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { Float } from '@headlessui-float/vue'

interface Props {
  oriDate: string[] | null
}

const props = defineProps<Props>()
const emit = defineEmits(['update:modelValue'])
const selDate = ref()
const dateOpt = [
  { label: 'Last 24 Hours', value: '24hours' },
  { label: 'Last 7 Days', value: '7days' },
  { label: 'Last 2 Weeks', value: '2weeks' },
  { label: 'Last 1 Month', value: '1month' },
]

onMounted(() => {
  selDate.value = props.oriDate
})

watch(() => props.oriDate, (value) => {
  // to watch parent reset
  selDate.value = value
})

function setValue(val: string) {
  if (val === selDate.value)
    selDate.value = null
  else
    selDate.value = val

  emit('update:modelValue', selDate.value)
}
</script>

<template>
  <div>
    <Listbox v-slot="{ open }" @update:model-value="(item: string) => setValue(item)">
      <Float portal placement="bottom-start" :z-index="0">
        <ListboxButton :class="`${open ? 'border-primary-400' : ''} ${!isEmpty(selDate) ? 'border-primary-400 bg-[#ECE9FC] text-[#5843E5] font-semibold' : 'bg-white border-gray-200'} flex items-center relative pl-4 pr-10 py-1.5 rounded-md text-sm border`">
          <span class="block truncate">{{ (!isEmpty(selDate) && selDate !== 'all') ? dateOpt.find(obj => obj.value === selDate)?.label : 'Date Posted' }}</span>
          <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <Icon v-if="!open" name="mdi:chevron-down" class="h-4 w-4" aria-hidden="true" />
            <Icon v-else name="mdi:chevron-up" class="h-4 w-4" aria-hidden="true" />
          </span>
        </ListboxButton>
        <ListboxOptions class="w-full lg:w-56 rounded-md shadow-lg py-4 bg-white fixed">
          <div class="font-bold mb-2 px-4">
            Date Posted
          </div>
          <ListboxOption v-for="(item, idx) in dateOpt" v-slot="{ active }" :key="idx" :value="item.value" as="template">
            <li :class="`cursor-pointer select-none px-4 pt-4 focus:outline-none hover:bg-primary-50 text-sm ${(active || selDate === item.value) ? 'bg-primary-50' : ''}`">
              <div :class="`${idx < (dateOpt.length - 1) ? 'border-b-1' : ''} pb-4`">
                {{ item.label }}
              </div>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </Float>
    </Listbox>
  </div>
</template>
